import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiComponentsModule } from '@finxone-platform/ui-components';
import { AlertHandlerComponent } from './alert-handler.component';
@NgModule({
  declarations: [AlertHandlerComponent],
  imports: [UiComponentsModule, CommonModule],
  exports: [AlertHandlerComponent],
})
export class AlertHandlerModule {}
